import GlossaryComponent from './GlossaryComponent';

export default GlossaryComponent;
